import React from "react";
import T from "prop-types";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import {
  HEIGHT,
  LENGTH,
  WEIGHT,
  WEIGHT_UNIT,
  WIDTH
} from "MODULES/parts/constants";
import ConvertedWeight from "../ConvertedWeight";
import Weight from "../Weight";
import Dimensions from "../Dimensions";
import CentimeterDimensions from "../CentimeterDimensions";

export function WeightAndDimensionsSection({
  width,
  height,
  length,
  weight,
  weight_unit,
  dimensionsRequired,
  weightRequired,
  weightLabel = "Weight"
}) {
  return (
    <FormRow>
      <Col md={3}>
        <Weight required={weightRequired} label={weightLabel} />
      </Col>
      <Col md={2}>
        <ConvertedWeight
          unit={weight_unit.input.value}
          weight={weight.input.value}
        />
      </Col>
      <Col md={4}>
        <Dimensions required={dimensionsRequired} />
      </Col>
      <Col md={3}>
        <CentimeterDimensions
          width={width.input.value}
          height={height.input.value}
          length={length.input.value}
        />
      </Col>
    </FormRow>
  );
}

export default withFormFields(WeightAndDimensionsSection, [
  WIDTH,
  HEIGHT,
  LENGTH,
  WEIGHT,
  WEIGHT_UNIT
]);

WeightAndDimensionsSection.propTypes = {
  width: F.formField(F.malleable).isRequired,
  height: F.formField(F.malleable).isRequired,
  length: F.formField(F.malleable).isRequired,
  weight: F.formField(F.malleable).isRequired,
  weight_unit: F.formField(F.stringInput).isRequired,
  weightLabel: T.string,
  dimensionsRequired: T.bool,
  weightRequired: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/FormSections/WeightAndDimensionsSection.jsx